import styled from '@emotion/styled';
import { pxToEm } from 'theme';

export const Content = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(324px, 1fr));
  gap: ${pxToEm(16)};
  margin: 0;
  padding: 0;
  list-style: none;
`;
